import Cookies from 'js-cookie'

export interface CookieOption {
  default: boolean
  headline: string
  key: number
  text: string
  vital: boolean
}

const COOKIE_NAME = 'cookieOptions'
export const COOKIE_CHANGE_EVENT_NAME = 'cookieChange'

export type PersistedCookieOptions = Record<number, boolean>

/**
 * Get current cookie options from the document
 */
export const getOptions = (): PersistedCookieOptions | null => {
  const content = Cookies.get(COOKIE_NAME)
  if (content) {
    return JSON.parse(content) as PersistedCookieOptions
  }
  return null
}

export const saveOptions = (options: PersistedCookieOptions): void => {
  const changeEvent: CustomEvent = new CustomEvent(COOKIE_CHANGE_EVENT_NAME, {
    bubbles: true,
    detail: options,
    composed: true,
    cancelable: true,
  })
  document.dispatchEvent(changeEvent)
  Cookies.set(COOKIE_NAME, JSON.stringify(options), {expires: 730, SameSite: window.location.protocol === 'https:' ? 'None' : 'Lax', secure: window.location.protocol=== 'https:'})
}

export const toPersistedCookieOptions = (
  allOptions: CookieOption[],
  selectedOptions: CookieOption[],
): PersistedCookieOptions => {
  return allOptions.reduce(
    (acc: PersistedCookieOptions, i: CookieOption) => ({...acc, [i.key]: i.vital || selectedOptions.includes(i)}),
    {},
  )
}

export const fromPersistedCookieOptions = (
  allOptions: CookieOption[],
  persistedOptions: PersistedCookieOptions,
): CookieOption[] => {
  return allOptions.filter((o) => !!persistedOptions[o.key])
}
